<template>
  <div>
    <h5>{{ status }}</h5>
  </div>
</template>

<script>

import {capitalize} from '../utils'

export default {
  name: 'OrdersTableCellStatus',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    status: function () {
      return capitalize(this.row.info.status.code)
    }
  },
  components: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrdersTableCellStatus.vue